import { isNewCatalogUser } from '../../utils/utils';
import { WIZARD_URL_FRAGMENT } from '../../constants/Navigation';
import { Redirect, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { isNewUser } from 'academy-common-lib/utils/url';
import { NEW_USER_SEARCH_PARAMS_KEY } from 'academy-navigation-lib/components/ACPage/ACPage';
import { jsx as _jsx } from "react/jsx-runtime";
const NewUserLanding = () => {
  const location = useLocation();
  useEffect(() => {
    if (isNewUser(location.search)) {
      try {
        localStorage.setItem(NEW_USER_SEARCH_PARAMS_KEY, location.search);
      } catch (error) {
        console.error(error);
      }
    }
  }, [location.search]);
  if (location.pathname !== '/' || !isNewCatalogUser(location.search)) {
    return null;
  }
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: WIZARD_URL_FRAGMENT
    })
  });
};
export default NewUserLanding;